import { Component, OnInit } from '@angular/core';
import { PollService } from 'src/app/core/http/poll/poll.service';
import { ActivatedRoute } from '@angular/router';
import { SchemaService } from 'src/app/shared/services/schema/schema.service';
import { forkJoin } from 'rxjs';
@Component({
  selector: 'app-poll',
  templateUrl: './poll.component.html',
  styleUrls: ['./poll.component.css']
})
export class PollComponent implements OnInit {
  poll_id = '0';
  poll;
  pollSchema = null;
  pollModel = {};
  send = false;
  response: any = [
    {
      'response': false,
      'resulttext': 'Результат не совпал',
      'resulttype': "ok",
      'resultcontent': null
    }
  ];

  constructor(private pollService: PollService, private route: ActivatedRoute, private schemaService: SchemaService) {
    this.poll_id = this.route.snapshot.paramMap.get("id");
  }

  ngOnInit(): void {
    this.GetPoll();
  }

  GetPoll() {
    forkJoin([this.pollService.getPollFields(this.poll_id), this.pollService.getCurrentPoll(this.poll_id)]).subscribe( res   => {
      
      console.log(res[1]);
      this.poll = res[1];
      this.pollSchema = this.schemaService.createSchema(res[0]); 
    })
  }

  saveAnswer(data) {
    var fields = this.schemaService.reModelPoll(data);
    let answer = {fields};
    this.pollService.run(this.poll_id, {answer})
    .subscribe(()=> {
      this.send = true;
    });
  }
}
